export default "__VITE_ASSET__CiN7fSVB__"